import React from "react";
import PropTypes from "prop-types";

// HELPERS
import { createClassName } from "@helpers/utils";


export default class ActivityIndicator extends React.PureComponent {
    static propTypes = {
        busy: PropTypes.bool,
        scale: PropTypes.number,
        width: PropTypes.number,
        color: PropTypes.string,
    }
    static defaultProps = {
        busy: true,
        scale: 1,
        width: 2,
    }

    size = 38

    render() {
        const { props, size } = this;
        const { busy, scale, width, color } = props;
        const classes = createClassName(props.className, {
            "ActivityIndicator": true,
            "active": busy,
        });
        const circleStyle = {
            stroke: color,
        };

        return (
            <div className={ classes } style={{ width: size * scale, height: size * scale }}>
                <svg width={ size } height={ size } viewBox={ `0 0 ${ size } ${ size }` } xmlns="http://www.w3.org/2000/svg" style={{
                    transform: `scale(${ scale })`,
                }}>
                    <circle style={ circleStyle } fill="none" strokeWidth={ width } strokeLinecap="round" cx={ size / 2 } cy={ size / 2 } r={ (size / 2) - width } />
                </svg>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ActivityIndicator/ActivityIndicator.js